import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, TermFilter, FilterOptions, StudentSexOptions } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/students/StudentsAction";
import { useStudentsUIContext } from "../StudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, studentNumber, identityCard, sex, sectionId } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  const newQueryParams = { ...queryParams };
  const filter = { studentNumber, identityCard, sex, sectionId };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function StudentsFilter() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      setQueryParams: studentsUIContext.setQueryParams,
      queryParams: studentsUIContext.queryParams,
    };
  }, [studentsUIContext]);
  
  const dispatch = useDispatch();
  const { currentActiveTerm, sections } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      sections: state.students.sections
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getAllSections());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(studentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentsUIProps.setQueryParams(newQueryParams);
    }
  };

  const studentSexOptions = FilterOptions.concat(StudentSexOptions);
  const sectionOptions = FilterOptions.concat(sections);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        studentNumber: "",
        identityCard: {
          tcKimlikNo: "",
          name: "",
          surname: ""
        }
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="credit"
                min={1}
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.identityCard.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("identityCard.tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.identityCard.name}
                onChange={(e) => {
                  setFieldValue("identityCard.name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.identityCard.surname}
                onChange={(e) => {
                  setFieldValue("identityCard.surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={studentSexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sectionOptions}
                value={values.sectionId}
                placeholder="Şube"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sectionId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>            
          </div>
        </form>
      )}
    </Formik>
  );
}